import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.241 6.555c-1.22-1.763-3.114-2.003-3.779-2.022-1.59-.165-3.13.942-3.941.942-.826 0-2.073-.925-3.416-.898-1.73.026-3.348 1.018-4.235 2.556-1.831 3.138-.466 7.75 1.288 10.285.878 1.243 1.903 2.63 3.246 2.58 1.313-.053 1.804-.828 3.389-.828 1.57 0 2.03.829 3.4.798 1.408-.023 2.297-1.248 3.143-2.502 1.015-1.424 1.422-2.826 1.438-2.898-.033-.011-2.737-1.032-2.764-4.122-.023-2.578 2.133-3.832 2.231-3.89z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.237 0c-.95.043-2.137.67-2.821 1.49-.606.723-1.146 1.907-1.007 3.019 1.067.082 2.163-.55 2.848-1.374.656-.838 1.104-1.977.98-3.135z"
});

var SvgIos = function SvgIos(props) {
  return React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 17 20",
    width: 17
  }, props), _ref, _ref2);
};

export default SvgIos;